import { Component } from '@mycolorway/tao';
import { closest, matches } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import $ from 'jquery';

Component('tr-filter-editor', {
  mixins: [eventListenerMixin],

  properties: {
    performsUrl: {
      type: String,
    },

    empty: {
      type: Boolean,
      default: false,
      observer() {
        if (!this.empty) return;
        this.result.innerHTML = '';
      },
    },

    noMore: {
      type: Boolean,
      default: false,
      observer() {
        if (!this.noMore) return;
        this.loadMore.text = this.loadMore.dataset.emptyWith;
      },
    },

    loading: {
      type: Boolean,
      default: false,
      observer() {
        if (this.loading) {
          this.loadMore.text = this.loadMore.dataset.loadingWith;
        } else if (!this.noMore) {
          this.loadMore.text = this.loadMore.dataset.normal;
        }
      },
    },

    showMoreBtn: {
      type: Boolean,
      default: true,
    },

    currentPage: {
      type: Number,
      default: 1,
    },

    saving: {
      type: Boolean,
      default: false,
    },

    showGuide: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    this.filterForm = this.querySelector('.filter-form');
    this.result = this.querySelector('.result-container');
    this.loadMore = this.querySelector('#btn-load-more');
    this.fieldsMenu = this.querySelector('.fields-menu');
    this.previewBtn = this.querySelector('.preview-btn');
    this.sortOrder = this.querySelector('.sort-order');
    this.total = this.querySelector('.total span');
    this.form = this.querySelector('.filter-editor-form .tr-form');
    this.saveDialog = this.querySelector('.save-dialog');
    this.moreSetting = this.querySelector('.more-settings');
    this.removeDialog = this.querySelector('.remove-dialog');
    this.savedFiltersMenu = this.querySelector('.saved-filters-menu');
    this.sideBar = this.querySelector('.filter-editor-form');
    this.exportBtn = this.querySelector('.more-settings .export');

    this.addEventListeners();
    this.fetchItems();
  },

  disconnected() {
    this.stopListening();

    $(this).off('ajax:beforeSend', '.save-filter, .save-dialog .tr-form');
    $(this).off('ajax:success', '.save-filter');
    $(this).off('submit', '.filter-form');
  },

  addEventListeners() {
    this.listenTo(this, 'click', this.handleSelfClick.bind(this));
    this.listenTo(this.sortOrder, 'tao:change', this.filterResult.bind(this));
    this.listenTo(this.previewBtn, 'click', () => {
      this.disablePreviewButton();
      this.filterResult();
    });
    this.listenTo(this.fieldsMenu, 'tao:selected', this.handleMenuSelect.bind(this));
    if (this.savedFiltersMenu) {
      this.listenTo(this.savedFiltersMenu, 'tao:selected', this.handleSavedFieldsMenuSelect.bind(this));
    }
    this.listenTo(this.loadMore, 'click', this.fetchNextPage.bind(this));
    this.listenTo(window, 'scroll', this.handleWindowScroll.bind(this));
    this.listenTo(this.form, 'click', this.handleFormClicked.bind(this));
    if (this.moreSetting) {
      this.listenTo(this.moreSetting, 'tao:selected', this.handleMoreSettingsSelected.bind(this));
    }
    if (this.removeDialog) {
      this.listenTo(this.removeDialog, 'tao:closed', this.handleRemoveDialogClosed.bind(this));
    }
    $(this).on('ajax:beforeSend', '.save-filter, .save-dialog .tr-form', (e, xhr, settings) => {
      // eslint-disable-next-line no-param-reassign
      settings.data += `&${$(this.filterForm).serialize()}&filter_form[sort_by]=${this.sortOrder.getValue()}`;
    });
    $(this).on('ajax:success', '.save-filter', () => {
      this.showSavedMessage();
    });

    $(this).on('submit', '.filter-form', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  },

  export() {
    const filterData = $(this.filterForm).serialize();
    const sortBy = $.param({ filter_form: { sort_by: this.sortOrder.getValue() } });
    $.ajax({
      url: this.exportBtn.dataset.link,
      type: 'get',
      dataType: 'script',
      data: `${filterData}&${sortBy}`,
    });
  },

  showSavedMessage() {
    const savedMessage = this.querySelector('.saved-message');
    savedMessage.classList.add('show');

    setTimeout(() => {
      savedMessage.classList.remove('show');
    }, 1000);
  },

  handleSelfClick(event) {
    if (this.showGuide) {
      this.showGuide = false;
    } else if (closest(event.target, 'tr-dialog') && closest(event.target, '.button-cancel')) {
      closest(event.target, 'tr-dialog').close();
    }
  },

  handleSavedFieldsMenuSelect(event) {
    const { item } = event.detail;
    window.tower.stack.load(item.dataset.value, {
      nocache: true,
      replace: true,
    });
  },

  handleFormClicked(event) {
    if (!matches(event.target, 'i.twr')) return;
    this.toggleField(event.target.dataset.key, false);
  },

  handleMoreSettingsSelected(event) {
    const { item } = event.detail;
    if (item.dataset.value === 'rename' || item.dataset.value === 'save_new_filter') {
      $.ajax({
        url: item.dataset.link,
        type: 'get',
        dataType: 'script',
      });
    } else if (item.dataset.value === 'delete_filter') {
      this.removeDialog.open();
    } else if (item.dataset.value === 'export') {
      this.export();
    }
  },

  handleRemoveDialogClosed(event) {
    if (event.detail === 'yes') {
      $.ajax({
        url: event.target.dataset.link,
        type: 'delete',
        dataType: 'script',
      });
    }
  },

  openSaveDialog(dialogHtml) {
    this.insertAdjacentHTML('beforeend', dialogHtml);
  },

  handleMenuSelect(event) {
    const { item } = event.detail;
    this.toggleField(item.dataset.value, true);
  },

  handleMenuClicked(event) {
    const item = closest(event.target, '.mdc-list-item');
    if (!item) return;
    this.selectField(item.dataset.key);
  },

  toggleField(key, selected) {
    const inputWrapper = this.form.querySelector(`.filter-field.${key}`);
    const fieldMenuItem = this.fieldsMenu.querySelector(`.mdc-list-item.${key}`);
    const fieldComponent = inputWrapper.querySelector('.tr-form-input').children[0];

    this.form.append(inputWrapper);
    inputWrapper.classList.toggle('active', selected);
    fieldMenuItem.classList.toggle('active', selected);

    const emptyFields = this.fieldsMenu.querySelectorAll('.mdc-list-item:not(.active)').length === 1;
    this.fieldsMenu.classList.toggle('fields-empty', emptyFields);
    setTimeout(() => {
      fieldComponent.reset();
    }, 0);
  },

  handleWindowScroll() {
    if ((this.loadMore.getBoundingClientRect().top - (
      $(window).scrollTop() + window.innerHeight)) < 150) {
      this.fetchNextPage();
    }
  },

  filterResult() {
    this.reset();
    this.fetchItems();
  },

  setTotal(total) {
    this.total.innerHTML = total;
  },

  reset() {
    this.result.innerHTML = '';
    this.empty = false;
    this.loading = false;
    this.showMoreBtn = false;
    this.noMore = false;
    this.currentPage = 1;
    this.loadMore.text = this.loadMore.dataset.normal;
  },

  fetchNextPage() {
    if (this.noMore || this.loading) return;
    this.currentPage += 1;
    this.fetchItems();
  },

  fetchItems() {
    if (this.loading) return;
    this.loading = true;
    const data = new FormData(this.filterForm);
    data.append('page', this.currentPage);
    data.append('filter_form[sort_by]', this.sortOrder.getValue());
    data.append('_method', 'post');
    $.ajax(this.performsUrl, {
      data,
      processData: false,
      contentType: false,
      type: 'POST',
      dataType: 'script',
      complete: () => {
        this.loading = false;
        this.enablePreviewButton();
      },
    });
  },

  updateFilterResult(html) {
    this.empty = false;
    const result = document.createElement('div');
    result.innerHTML = html;
    const resultNode = result.children[0];

    const lastSegment = this.result.querySelector('.tr-filter-editor-result:last-child');
    if (lastSegment && lastSegment.dataset.lastGroupId === resultNode.dataset.firstGroupId) {
      resultNode.classList.add('hide-first-group-title');
    }
    this.result.appendChild(resultNode);
  },

  disablePreviewButton() {
    const buttonLabel = this.previewBtn.querySelector('.mdc-button__label');
    this.previewBtn.disabled = true;
    this.previewBtn.dataset.originalText = buttonLabel.textContent;
    buttonLabel.textContent = this.previewBtn.dataset.disableWith;
  },

  enablePreviewButton() {
    const { originalText } = this.previewBtn.dataset;
    if (!originalText) return;

    const buttonLabel = this.previewBtn.querySelector('.mdc-button__label');
    this.previewBtn.disabled = false;
    buttonLabel.textContent = this.previewBtn.dataset.originalText;
  },
});
